import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export function Field({ label, children, hint }) {
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      {children}
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}

export function ProfileFieldsForm({ v, set, prefix }) {
  const on = (k) => (e) => set({ ...v, [k]: e.target.value });
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <Field label="Nama lengkap">
          <Input className="h-11" value={v.full_name} onChange={on("full_name")} required data-testid={`${prefix}-fullname-input`} />
        </Field>
      </div>
      <Field label="Tanggal lahir">
        <Input className="h-11" type="date" value={v.dob} onChange={on("dob")} required data-testid={`${prefix}-dob-input`} />
      </Field>
      <Field label="Jenis kelamin">
        <select
          className="h-11 w-full rounded-md border border-input bg-transparent px-3 text-sm shadow-sm
            outline-none transition-colors focus:border-[#3D6F4B] focus:ring-2
            focus:ring-[#3D6F4B]/20 disabled:cursor-not-allowed disabled:opacity-50"
          value={v.gender}
          onChange={on("gender")}
          required
          data-testid={`${prefix}-gender-select`}
        >
          <option value="" disabled>
            Pilih
          </option>
          <option value="L" data-testid={`${prefix}-gender-L`}>
            Laki-laki
          </option>
          <option value="P" data-testid={`${prefix}-gender-P`}>
            Perempuan
          </option>
        </select>
      </Field>
      <Field label="Kota domisili">
        <Input className="h-11" value={v.city} onChange={on("city")} required data-testid={`${prefix}-city-input`} />
      </Field>
      <Field label="No. telepon darurat" hint="Hanya untuk keselamatan. Nomor luar negeri pakai kode negara (+60...).">
        <Input className="h-11" type="tel" value={v.emergency_phone} onChange={on("emergency_phone")} required data-testid={`${prefix}-emergency-input`} />
      </Field>
    </div>
  );
}

export const EMPTY_PROFILE = { full_name: "", dob: "", gender: "", city: "", emergency_phone: "" };
